import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=7280b568&scoped=true&"
import script from "./PercentageBar.vue?vue&type=script&lang=js&"
export * from "./PercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=7280b568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280b568",
  null
  
)

export default component.exports